import { memo } from 'react';

import {
  FileStatusButton,
  FileStatusIconErrored,
  FileStatusSubtitle,
  FileStatusTitle,
} from '@air/feature-file-status/ui';
import { Close } from '@air/next-icons';

import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { type ClipVideoTaskMetadata } from '~/components/VideoClipTasks/types';

export type VideoClipTaskPanelItemFailedProps = {
  metadata: ClipVideoTaskMetadata;
  onClear: () => void;
};

export const VideoClipTaskPanelItemFailed = memo(({ metadata, onClear }: VideoClipTaskPanelItemFailedProps) => {
  return (
    <PaneItemTW
      avatar={<FileStatusIconErrored />}
      title={<FileStatusTitle data-testid="VIDEO_CLIP_PANEL_FAILED_TITLE">Error saving video</FileStatusTitle>}
      subtitle={
        <FileStatusSubtitle className="truncate">
          {metadata?.saveResultAs?.as === 'assetVersion'
            ? 'Unable to create new version. Please try again.'
            : 'Unable to create new asset. Please try again.'}
        </FileStatusSubtitle>
      }
      buttons={
        <FileStatusButton label="Dismiss" onClick={onClear}>
          <Close className="size-4" />
        </FileStatusButton>
      }
    />
  );
});

VideoClipTaskPanelItemFailed.displayName = 'VideoClipTaskPanelItemFailed';
